/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SelectInput from "./SelectInput";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class TopicPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		this.getThemes();
	}

	getThemes = () => {
		GetItem(`/apps/${this.appKey}/topics`).then(data => {
			let values = [];
			data.data.forEach(topic => {
				values.push({
					key: topic.id,
					value: topic.id,
					label: `${topic.name} (${topic.recipientCount})`,
				});
			});
			const { experiences } = this.props;
			if (experiences && experiences.length) {
				experiences.forEach(exp => {
					values.push({
						key: exp.id,
						value: exp.id,
						label: `${exp.name} Experience (${exp.recipientCount})`,
					});
				});
			}
			this.setState({ values });
		});
	};

	render() {
		let { values } = this.state;
		return (
			<div className="picker-input">{values.length > 0 && <SelectInput {...this.props} values={values} />}</div>
		);
	}
}

TopicPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	experiences: PropTypes.array,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	experiences: state.experiences.experiences,
});

export default connect(mapStateToProps)(TopicPicker);
